import React from 'react';
import { Routes, Route } from 'react-router-dom';

import PageHome from '../pages/public/Home';
import PageOver from '../pages/public/Over';
import PageContact from '../pages/public/Contact';
import PagePlan from '../pages/plannen/Plan';
import PageNotFound from '../pages/public/NotFound';
import PageNotAuthorized from '../pages/public/NotAuthorized';
import PageUitloggen from '../pages/Uitloggen';
import ProtectedRoute from './ProtectedRoutes';
import PageInloggen from '../pages/public/Inloggen';
import PageStyles from '../pages/public/Styles';
import PageVerlopen from '../pages/public/Verlopen';
import PageOrganisaties from '../pages/authentication/Organisaties';
import PageMijnOrganisaties from '../pages/authentication/MijnOrganisaties';
import PageMijnOrganisatie from '../pages/authentication/MijnOrganisatie';
import PageMijnGegevens from '../pages/authentication/MijnGegevens';
import PagePlannenDashboard from '../pages/plannen/Dashboard';
import PagePlannenDelen from '../pages/plannen/Delen';
import PageStichting from '../pages/public/Stichting';
import PageFaq from '../pages/public/Faq';
import PageToegang from '../pages/public/Toegang';
import BodyClassManager from './BodyClassManager';
import PagePrivacyVerklaring from '../pages/public/Privacyverklaring';
import PageAlgemeneVoorwaarden from '../pages/public/AlgemeneVoorwaarden';
import PagePlannenImport from '../pages/plannen/Import';
import PagePortfolio from '../pages/portfolios/Portfolio';
import PagePortfolioOverzicht from '../pages/portfolios/Overzicht';
import PageOverIntegraalProgrammeren from '../pages/public/OverIntegraalProgrammeren';
import PageKosteloosGebruik from '../pages/public/KosteloosGebruik';
import PageLayers from '../pages/maps/Layers';
import PageLayersDelen from '../pages/maps/LayersDelen';
import PageKaartenImport from '../pages/maps/Import';
import PageConsortiums from '../pages/authentication/Consortiums';
import RoleGuard from './guards/roleGuard';

const ALL_ROLES = ['Admin', 'KeyUser', 'User', 'ReadOnly'];
const ADMIN_KEYUSER_ROLES = ['Admin', 'KeyUser'];
const ADMIN_ROLES = ['Admin'];


const Routing: React.FC = () => (
    <>
        {/* <BrowserRouter> */}
        <BodyClassManager />
        <Routes>
            {/* Public routes */}
            <Route index element={<PageHome />} />
            <Route path="/" element={<PageHome />} />
            <Route path="home" element={<PageHome />} />
            
            <Route path="styles" element={<PageStyles />} />
            <Route path="inloggen" element={<PageInloggen />} />
            <Route path="niet-gevonden" element={<PageNotFound />} />
            <Route path="niet-toegestaan" element={<PageNotAuthorized />} />
            <Route path="verlopen" element={<PageVerlopen />} />
            
            <Route path="over" element={<PageOver />} />
            <Route path="over-integraal-programmeren" element={<PageOverIntegraalProgrammeren />} />
            <Route path="kosteloos-gebruik" element={<PageKosteloosGebruik />} />

            <Route path="toegang" element={<PageToegang />} />
            <Route path="toegang-als-organisatie" element={<PageToegang />} />
            <Route path="toegang-tot-infraplannen" element={<PageToegang />} />
            <Route path="veelgestelde-vragen" element={<PageFaq />} />

            <Route path="contact" element={<PageContact />} />
            <Route path="over-mijnaansluiting" element={<PageStichting />} />

            <Route path="privacy" element={<PagePrivacyVerklaring />} />
            <Route path="algemene-voorwaarden" element={<PageAlgemeneVoorwaarden />} />
            <Route path="*" element={<PageNotFound />} />

            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
                <Route element={<RoleGuard allowedRoles={ALL_ROLES} />}>
                    <Route path="mijn" element={<PageMijnOrganisaties />} />
                    <Route path="mijn/organisaties" element={<PageMijnOrganisaties />} />
                    <Route path="mijn/organisatie/:id" element={<PageMijnOrganisatie />} />
                    <Route path="mijn/gegevens" element={<PageMijnGegevens />} />
                    <Route path="uitnodigen" element={<PagePlan />} />
                    <Route path="samenwerkingsverbanden" element={<PageConsortiums />} />

                    <Route path="plannen">
                        <Route index element={<PagePlannenDashboard />} />
                        <Route path=":id" element={<PagePlannenDashboard />} />
                    </Route>

                    <Route path="dossiers" element={<PagePortfolioOverzicht />} />
                    <Route path="dossiers/:id" element={<PagePortfolio />} />
                    <Route path="uitloggen" element={<PageUitloggen />} />
                </Route>

                <Route element={<RoleGuard allowedRoles={ADMIN_KEYUSER_ROLES} />}>
                    <Route path="mijn/plannen/delen" element={<PagePlannenDelen />} />
                    <Route path="mijn/plannen/importeren" element={<PagePlannenImport />} />
                    
                    <Route path="mijn/kaartlagen" element={<PageLayers />} />
                    <Route path="mijn/kaartlagen/zichtbaarheid" element={<PageLayersDelen />} />
                    <Route path="mijn/kaartlagen/importeren" element={<PageKaartenImport />} />
                </Route>

                <Route element={<RoleGuard allowedRoles={ADMIN_ROLES} />}>
                    <Route path="organisaties" element={<PageOrganisaties />} />
                </Route>

                {/* <Route path="plannen" element={<PageDashboard />} />
                <Route path="plannen/:id" element={<PagePlan />} /> */}
                {/* <Route path="plannen/*" element={<PageDashboard />} /> */}
                {/* <Route path="dashboard" element={<PageDashboard />} />
                <Route path="kaart" element={<PageMap />} />
                <Route path="plannen/:id" element={<PagePlan />} />

                {/* <Route path="/profile" element={<Profile />} /> */}
            </Route>

            {/* Nested voorbeeld under /item components ook nested met <Outlet />
            <Route path="plannen" element={<Items />}>
                <Route path=":id" element={<Item />} />
            </Route> */}
        </Routes>
    {/* </BrowserRouter> */}
    </>
);

export default Routing;
